module.exports = __webpack_public_path__ + "static/instagram-image-1-c3b0908ec4df45c4803af7ddb178c004.jpg";